import styled, { css } from 'styled-components';
import { getColorByName } from '~/helpers/getColors';
import { getPaddingX, getPaddingY, getFontSize } from '../CTA.helpers';
import { CTACommonBeforeStyles, CTAAnimationBasics } from './CTA.basic';
import { CTAprimarySkin } from './CTA.primary';

const CTAsecondarySkin = css`
  ${CTAprimarySkin};

  padding: ${(props) => getPaddingY(props.size) - 2}px
    ${(props) => getPaddingX(props.size)}px;

  font-size: ${(props) => getFontSize(props.size)};
  color: ${({ theme }) => getColorByName(theme, theme.cta.secondaryFontColor)};
  border: ${({ theme }) => theme.cta.secondaryBorderColor};
  background: ${(props) =>
    getColorByName(props.theme, props.theme.cta.secondaryBgColor)};
  line-height: ${(props) => props.theme.cta.secondaryLineHeight};
  transition: color 0.25s ease-out;

  .iconBefore,
  .iconAfter {
    svg {
      max-height: ${(props) => getFontSize(props.size)};
      width: auto;
    }
  }

  &:before {
    background-color: ${(props) =>
      getColorByName(props.theme, props.theme.cta.secondaryBgHoverColor)};
  }

  &:disabled {
    border: 1px solid ${(props) => props.theme.color.gray500};
  }

  ${({ theme, isBrand }) =>
    isBrand &&
    css`
      border: ${theme.cta.brand.secondaryBorder};

      &:before {
        ${CTACommonBeforeStyles};
        background: ${getColorByName(
          theme,
          theme.cta.brand.secondaryBgHoverColor,
        )};
      }
    `};
`;

export const CTAsecondaryWithAniIconSkin = css`
  ${CTAsecondarySkin};
  ${CTAAnimationBasics};

  .iconAfter {
    color: ${(props) =>
      props.theme.cta.secondaryIconHoverColor
        ? getColorByName(props.theme, props.theme.cta.secondaryIconHoverColor)
        : props.theme.color.cta};
  }
`;

export const CTAsecondary = styled.div`
  ${CTAsecondarySkin}
`;

export const CTAsecondaryWithAniIcon = styled.div`
  ${CTAsecondaryWithAniIconSkin}
`;
